import { render, staticRenderFns } from "./door-shop-set.vue?vue&type=template&id=3f9a3693&scoped=true&"
import script from "./door-shop-set.vue?vue&type=script&lang=js&"
export * from "./door-shop-set.vue?vue&type=script&lang=js&"
import style0 from "./door-shop-set.vue?vue&type=style&index=0&id=3f9a3693&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9a3693",
  null
  
)

export default component.exports